import { createContext, useState } from 'react';

const UIContext = createContext({});

export const UIContextProvider = ({ children }) => {
  const [loader, setLoader] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [alterType, setAlterType] = useState('success');
  const [alterMessage, setAlterMessage] = useState('');

  const closeSnackBar = () => {
    setShowSnackBar(false);
    setAlterMessage('');
  };

  const openSnackBar = (message, type = 'success') => {
    setShowSnackBar(true);
    setAlterType(type);
    setAlterMessage(message);
  };
  const showLoader = () => {
    setLoader(true);
  };
  const hideLoader = () => {
    setLoader(false);
  };
  return (
    <UIContext.Provider
      value={{
        loader,
        setLoader,
        showLoader,
        hideLoader,
        showSnackBar,
        alterType,
        alterMessage,
        closeSnackBar,
        openSnackBar,
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

export default UIContext;
